import React from 'react';
import { ProductDetail } from './pages/ProductDetail';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <ProductDetail data-id="element-1" />
    </div>;
}